var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 18.334H5.833c-.92 0-1.666-.747-1.666-1.667V5.834H2.5V4.167h3.333v-.833c0-.92.747-1.667 1.667-1.667h5c.92 0 1.667.746 1.667 1.667v.833H17.5v1.667h-1.667v10.833c0 .92-.746 1.667-1.666 1.667zm-8.334-12.5v10.833h8.334V5.834H5.833zm1.667-2.5v.833h5v-.833h-5zM12.5 15h-1.667V7.5H12.5V15zm-3.333 0H7.5V7.5h1.667V15z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.c406b90d787b96081a6ae7926dc374f2.svg";
export { ForwardRef as ReactComponent };